"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const luxon_1 = require("luxon");
const User_1 = require("./User");
class ProjectIssueComment {
    constructor({ id, body, user, createdAt, updatedAt, }) {
        this.toJSON = () => ({
            id: this.id,
            body: this.body,
            user: this.user,
            createdAt: this.createdAt.toISO(),
            updatedAt: this.updatedAt.toISO(),
        });
        this.id = id;
        this.body = body;
        this.user = user;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
    }
}
ProjectIssueComment.fromJSON = (json) => {
    const { id, body, user, createdAt, updatedAt } = Object.assign({}, json);
    if (typeof id !== 'string')
        throw new Error('.id must be a string');
    if (typeof body !== 'string')
        throw new Error('.body must be a string');
    if (typeof createdAt !== 'string')
        throw new Error('.createdAt must be a string');
    if (typeof updatedAt !== 'string')
        throw new Error('.updatedAt must be a string');
    return new ProjectIssueComment({
        id,
        body,
        user: User_1.DirectorUser.fromJSON(user),
        createdAt: luxon_1.DateTime.fromISO(createdAt),
        updatedAt: luxon_1.DateTime.fromISO(updatedAt),
    });
};
exports.default = ProjectIssueComment;
